import Image from 'next/image';
import Link from 'next/link';
import { Fragment } from 'react';

import { Downloads } from '../../../interface/products';
import { ProductImage } from '../../../interface/strapi';
import { ProductContentTabs } from '../../../enums/productTabs';
import { brandColors } from '../../../constants/colors';
import { FeatureCardType } from '../../../types/content';
import FeatureCards from '../../molecules/feature-cards/feature-cards';
import HeroCarousel from '../../molecules/hero-carousel/hero-carousel';

/* eslint-disable-next-line */
type ProductTabsProps = {
  activeTab: string;
  downloads: Downloads[];
  featureCardsContent: FeatureCardType[];
  heroImages: ProductImage[];
  swiperColor: string;
};

export function ProductTabs(props: ProductTabsProps) {
  const { activeTab, downloads, featureCardsContent, heroImages, swiperColor } =
    props;

  const textColor =
    swiperColor === brandColors.SUBZERO_HEX
      ? 'hover:text-primaryBlue'
      : 'hover:text-primaryRed';

  const renderDownloads = downloads.map((download) => {
    return (
      <div key={download.id} className="flex items-center space-y-1">
        <div className="w-6 h-6 relative flex-shrink-0">
          <Image
            alt="pdf icon"
            layout="fill"
            objectFit="contain"
            src="/icons/pdf-icon.png"
          />
        </div>

        <Link href={download.File.data.attributes.url} passHref>
          <a
            target="_blank"
            rel="noreferrer"
            className={`font-MuseoSans100 ${textColor} pl-2 text-caption lg:text-subtitle`}
          >
            {download.Name}
          </a>
        </Link>
      </div>
    );
  });

  switch (activeTab) {
    case ProductContentTabs.FEATURES: {
      return (
        <div className="py-12 lg:py-24 flex justify-center">
          <FeatureCards
            featureCardsContent={featureCardsContent}
            swiperColor={swiperColor}
          />
        </div>
      );
    }
    case ProductContentTabs.IMAGE_GALLERY: {
      return (
        <div className="py-12 lg:py-24">
          <HeroCarousel heroImages={heroImages} swiperColor={swiperColor} />
        </div>
      );
    }
    case ProductContentTabs.DOWNLOADS: {
      return <div className="p-6 lg:p-24">{renderDownloads}</div>;
    }
    default:
      return <Fragment />;
  }
}

export default ProductTabs;
